import { Instance } from 'mobx-state-tree'
import { DashboardGameModelBase } from './DashboardGameModel.base'

/* The TypeScript type of an instance of DashboardGameModel */
export interface DashboardGameModelType extends Instance<typeof DashboardGameModel.Type> {}

/* A graphql query fragment builders for DashboardGameModel */
export {
  selectFromDashboardGame,
  dashboardGameModelPrimitives,
  DashboardGameModelSelector
} from './DashboardGameModel.base'

/**
 * DashboardGameModel
 */
export const DashboardGameModel = DashboardGameModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
